export default __webpack_public_path__ + "static/map-d39d72868a16d68a7abae8612fce3f76.png";